import React from 'react'
import { HeaderPage, Logo } from './header-style'

const Header = () => {
  return (
    <HeaderPage>
      <Logo>Aberto</Logo>
    </HeaderPage>
  )
}

export default Header
